var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "channel-detail-panel",
      class: { "channel-detail-panel-sm": _vm.windowIsSmall },
    },
    [
      _c(
        "div",
        { staticClass: "col-1" },
        [
          _vm._t("beforethumbnail"),
          _vm.channel.thumbnail
            ? _c("img", {
                staticClass: "thumbnail",
                attrs: { src: _vm.channel.thumbnail },
              })
            : _c("KIcon", {
                staticClass: "thumbnail-svg",
                style: { backgroundColor: _vm.$themePalette.grey.v_200 },
                attrs: { icon: "channel" },
              }),
        ],
        2
      ),
      _c("div", { staticClass: "col-2" }, [
        _c("div", { staticClass: "col-2-row-1" }, [
          _c(
            "div",
            [
              _c(
                "h2",
                { staticClass: "channel-name", attrs: { dir: "auto" } },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.channel.name) + "\n        "
                  ),
                ]
              ),
              _vm._t("belowname"),
              _c(
                "p",
                {
                  staticClass: "version",
                  style: { color: _vm.$themeTokens.annotation },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$tr("versionNumber", {
                          v: _vm.channelVersion || _vm.channel.version,
                        })
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ],
            2
          ),
        ]),
        _c(
          "div",
          [
            _vm._t("abovedescription"),
            _c("p", { staticClass: "description", attrs: { dir: "auto" } }, [
              _vm.channel.description
                ? _c("span", [_vm._v(_vm._s(_vm.channel.description))])
                : _c(
                    "span",
                    { style: { color: _vm.$themeTokens.annotation } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$tr("defaultDescription")) +
                          "\n        "
                      ),
                    ]
                  ),
            ]),
            _c(
              "p",
              { staticClass: "coach-content" },
              [
                _c("CoachContentLabel", {
                  attrs: {
                    value: _vm.channel.num_coach_contents,
                    isTopic: true,
                  },
                }),
              ],
              1
            ),
            _vm._t("belowdescription"),
          ],
          2
        ),
      ]),
      _vm._t("append"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }